import {DateRangeLabels, PatientAgeRange, TableFiltersValidationSchema} from '@/types'
import {AssistiveRegimeEnum, ProjectIndex} from '@/features/projects/types'
import {AccessRateCode} from '@/features/accesses/types'

export const rangeDateToLabel = {
    today: 'range_date:today',
    yesterday: 'range_date:yesterday',
    last_week: 'range_date:last_week',
    last_month: 'range_date:last_month',
    last_3_months: 'range_date:last_3_months',
    last_6_months: 'range_date:last_6_months',
    last_year: 'range_date:last_year'
} as const satisfies Record<DateRangeLabels, string>

export const calculateAccessRateCode = ({
    sector,
    serviceType,
    assistiveRegime
}: {
    sector: ProjectIndex['sector']
    serviceType: PatientAgeRange
    assistiveRegime: AssistiveRegimeEnum | undefined
}): AccessRateCode | undefined => {
    if (sector === 'outpatient') {
        if (serviceType === 'evolutionary_age') {
            return 'AA1'
        }

        if (serviceType === 'adults') {
            if (assistiveRegime === 'autism') {
                return 'AA2'
            }
            return 'AM'
        }

        if (serviceType === 'evolutionary_age_adults') {
            if (assistiveRegime === 'autism') {
                return 'AA2'
            }
            return 'AM'
        }
    }

    if (sector === 'domiciliary') {
        if (serviceType === 'evolutionary_age') {
            return 'D2'
        }

        if (serviceType === 'adults' || serviceType === 'evolutionary_age_adults') {
            return 'D1'
        }
    }
}

/**
 * Extracts a filter value from a table filters schema based on the provided key and optional operator.
 *
 * This utility function searches through the filter fields to find a matching field by key,
 * and optionally by operator, then returns the value of that field.
 *
 * @param filters - The table filters validation schema containing an array of filter fields
 * @param key - The key to search for in the filter fields
 * @param operator - Optional operator to match against the field's operator (if not provided, any operator will match)
 *
 * @returns The value of the matching filter field, or undefined if no match is found
 */
export const extractFilterValue = (filters: TableFiltersValidationSchema, key: string, operator?: string): unknown => {
    const field = filters.fields.find(field => field.key === key && (!operator || field.operator === operator))
    return field?.value
}
